import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import PageContainer from '../../@layout/PageContainer';
import { ModuleProps } from '../../../types';
import HeaderBar from '../HeaderBar';
import SingleSignOnPanel from './components/SingleSignOnPanel';
import OneTimeImportPanel from './components/OneTimeImportPanel';
import ManualEntryPanel from './components/ManualEntryPanel';
import ContactUsPanel from 'components/@common/ContactUsPanel';
import config from 'config';
import EndOfYearProcessingPanel from 'components/EndOfYearProcessing/components/EndOfYearProcessingPanel';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: `${theme.spacing(3)}px`,
      padding: `${theme.spacing(3)}px ${theme.spacing(5)}px`
    },
    header: {
      textAlign: 'center',
      margin: 'auto'
    },
    panelSummaryContent: {
      margin: `${theme.spacing(2.5)}px 0`
    },
    detailsContainer: {
      paddingTop: 0
    },
    productCardsContainer: {
      marginTop: theme.spacing(2)
    }
  };
});

const AdminRosterManagement: React.FC<ModuleProps> = props => {
  const classes = useStyles();
  const { t } = useTranslation('AdminRosterManagement');
  return (
    <PageContainer>
      <HeaderBar {...props} />
      <div className={classes.container}>
        <EndOfYearProcessingPanel />
        <Typography variant="h2" className={classes.header}>
          {t('How will you share your educator and student information?')}
        </Typography>
        <SingleSignOnPanel />
        <OneTimeImportPanel />
        <ManualEntryPanel />
        <ContactUsPanel contactUsUrl={config.rosteringSupportUrl} />
      </div>
    </PageContainer>
  );
};

export default AdminRosterManagement;
